document.addEventListener("DOMContentLoaded", function () {

  const wishlistKey = "aanzri_wishlist";


  function getWishlist() {

    try {

      const wishlist = JSON.parse(
        localStorage.getItem(wishlistKey)
      );

      return Array.isArray(wishlist)
        ? wishlist
        : [];

    } catch (error) {

      console.error(
        "Wishlist read error:",
        error
      );

      return [];

    }

  }


  function saveWishlist(wishlist) {

    try {

      localStorage.setItem(
        wishlistKey,
        JSON.stringify(wishlist)
      );


      window.dispatchEvent(
        new CustomEvent(
          "aanzriWishlistUpdated",
          {
            detail: {
              wishlist: wishlist
            }
          }
        )
      );


    } catch (error) {

      console.error(
        "Wishlist save error:",
        error
      );

    }

  }


  function updateWishlistCount() {

    const wishlist = getWishlist();


    document
      .querySelectorAll(
        "[data-aanzri-wishlist-count]"
      )
      .forEach(function (element) {


        element.textContent = wishlist.length;


        if (wishlist.length > 0) {

          element.classList.add("has-items");

        } else {

          element.classList.remove("has-items");

        }


      });

  }


  function updateWishlistButtons() {

    const wishlist = getWishlist();


    const handles = wishlist.map(
      function (item) {

        return item.handle;

      }
    );


    document
      .querySelectorAll(
        "[data-aanzri-wishlist]"
      )
      .forEach(function (button) {


        const handle =
          button.dataset.productHandle;


        if (!handle) return;


        if (handles.includes(handle)) {


          button.classList.add(
            "is-active"
          );


          button.setAttribute(
            "aria-label",
            "Remove from wishlist"
          );


        } else {


          button.classList.remove(
            "is-active"
          );


          button.setAttribute(
            "aria-label",
            "Add to wishlist"
          );


        }


      });

  }


  document.addEventListener(
    "click",
    function (event) {


      const button =
        event.target.closest(
          "[data-aanzri-wishlist]"
        );


      if (!button) return;


      event.preventDefault();

      event.stopPropagation();


      const handle =
        button.dataset.productHandle;


      const title =
        button.dataset.productTitle;


      const url =
        button.dataset.productUrl;


      const image =
        button.dataset.productImage;


      const price =
        button.dataset.productPrice;


      if (!handle) {

        console.error(
          "Wishlist error: Product handle missing"
        );

        return;

      }


      let wishlist =
        getWishlist();


      const existingIndex =
        wishlist.findIndex(
          function (item) {

            return item.handle === handle;

          }
        );


      if (existingIndex > -1) {


        wishlist.splice(
          existingIndex,
          1
        );


      } else {


        wishlist.push({

          handle: handle,

          title: title || "",

          url: url || (
            "/products/" + handle
          ),

          image: image || "",

          price: price || ""

        });


      }


      saveWishlist(wishlist);


      updateWishlistCount();

      updateWishlistButtons();


    }
  );


  window.addEventListener(
    "aanzriWishlistUpdated",
    function () {

      updateWishlistCount();

      updateWishlistButtons();

    }
  );


  window.addEventListener(
    "storage",
    function (event) {

      if (event.key === wishlistKey) {

        updateWishlistCount();

        updateWishlistButtons();

      }

    }
  );


  updateWishlistCount();

  updateWishlistButtons();


});